import dayjs from 'dayjs';
import { at } from 'lodash';
import PropTypes from 'prop-types';
import { useField, useFormikContext } from 'formik';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';

interface HourPickerProps {
  label: string;
  name: string;
  views?: ('hours' | 'minutes' | 'seconds')[];
  [key: string]: any;
}

function HourPicker(props: HourPickerProps) {
  const [field, meta] = useField(props);
  const formikProps = useFormikContext();
  const { label, ...otherProps } = props;

  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
    return '';
  }

  const handleChange = (value: dayjs.Dayjs | null) => {
    formikProps.setFieldValue(field.name, value);
  };

  // Verifica que el valor sea un objeto dayjs válido
  const parsedValue = field.value && dayjs.isDayjs(field.value) ? field.value : dayjs(field.value);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        {...otherProps}
        label={label}
        value={parsedValue}
        onChange={handleChange}
        views={['hours', 'minutes']}
        slotProps={{
          textField: {
            error: meta.touched && Boolean(meta.error),
            helperText: _renderHelperText(),
          },
        }}
      />
    </LocalizationProvider>
  );
}

export default HourPicker;
